import React from "react";
import i18n, { t } from "@/i18n";
import { func, string, bool } from "prop-types";
import countries from "localized-countries";
import swedishCountryNames from "localized-countries/data/sv.json";
import englishCountryNames from "localized-countries/data/en.json";
import Select from "@/components/select";
const CountrySelect = React.memo(
  ({
    labelProp,
    valueProp,
    value,
    onChange,
    disabled,
    placeholderTid,
    className,
  }) => {
    const language = i18n.language ?? "en";

    const countryNames = language?.startsWith("sv")
      ? swedishCountryNames
      : englishCountryNames;

    const options = countries(countryNames)
      .array()
      .map((country) => {
        return {
          value: country[valueProp],
          label: country[labelProp],
        };
      });

    return (
      <Select
        className={className}
        value={value}
        options={options}
        onChange={onChange}
        disabled={disabled}
        placeholder={t(placeholderTid)}
      />
    );
  },
);

CountrySelect.displayName = "CountrySelect";

CountrySelect.propTypes = {
  value: string,
  onChange: func,
  disabled: bool,
};

CountrySelect.defaultProps = {
  labelProp: "label",
  valueProp: "code",
  disabled: false,
  placeholderTid: "country.placeholder",
};

export default CountrySelect;
